import { BASE_PRE_ORDER_PATH } from '../paths';

export const PRE_ORDER_GENETICS_BASE_PATH = `${BASE_PRE_ORDER_PATH}/genetics`;

export const PRE_ORDER_GENETICS_ELIGIBILITY_PATH = `${PRE_ORDER_GENETICS_BASE_PATH}/:programCode`;
export const PRE_ORDER_GENETICS_ELIGIBILITY_CONFIRMATION_PATH = `${PRE_ORDER_GENETICS_ELIGIBILITY_PATH}/confirmation`;

// PC-1274 - Redirects to handle old Angular routes
// These can be removed once we have communicated with genetics benefits users
// that they will no longer be supported
export const PRE_ORDER_GENETICS_REDIRECT_PATHS = [
  '/go',
  '/go/:company',
  '/benefits/for-employees',
  '/benefits/employees',
];
